import { countryList, states } from '../utils/Constants';

export class WebinarHsForm {
	constuctor() {
		this.form = null;
		this.country = null;
		this.state = null;
	}

	initialize() {
		let intervalCounter = 0;
		const interval = setInterval(() => {
			if (intervalCounter > 9) {
				clearInterval(interval);
			}

			intervalCounter++;

			const form = document.querySelector(
				'.webinar-hs-form-wrapper .hs-form'
			);
			if (!form) {
				return;
			}
			this.form = form;

			const countryElement = this.createCountrySelect();
			const country = form.querySelector('input[name=country]');
			if (!country) {
				return;
			}
			this.country = country;

			country.parentNode.appendChild(countryElement);
			countryElement.addEventListener('change', (e) =>
				this.countrySelectChangeHandler(e)
			);

			clearInterval(interval);
		}, 100);
	}

	createCountrySelect() {
		if (!Array.isArray(countryList)) {
			return '';
		}

		const select = document.createElement('select');
		select.classList.add('hs-input');
		select.name = 'hsf_country';
		select.setAttribute('required', 'required');
		countryList.forEach((country) => {
			select.innerHTML += `<option value="${country}">${country}</option>`;
		});

		return select;
	}

	createStateSelect() {
		if (!Array.isArray(states)) {
			return '';
		}

		const select = document.createElement('select');
		select.classList.add('hs-input');
		select.classList.add('active');
		select.name = 'hsf_state';
		select.setAttribute('required', 'required');
		states.forEach((state) => {
			select.innerHTML += `<option value="${state}">${state}</option>`;
		});

		return select;
	}

	countrySelectChangeHandler(e) {
		const target = e.target;

		const form = this.form;

		const country = target.selectedOptions[0].value;
		this.updateCountryField(target.selectedOptions[0].value);

		if (country === 'United States') {
			const stateElement = this.createStateSelect();
			const state = form.querySelector('input[name=state]');
			if (!state) {
				return;
			}

			this.state = state;

			state.parentNode.appendChild(stateElement);
			stateElement.addEventListener('change', (e) =>
				this.stateSelectChangeHandler(e)
			);
			this.updateStateField(stateElement.selectedOptions[0].value);
		} else {
			const stateElement = document.querySelector(
				'select[name=hsf_state]'
			);
			if (stateElement) {
				this.state = null;
				stateElement.remove();
			}
		}
	}

	stateSelectChangeHandler(e) {
		const target = e.target;

		this.updateStateField(target.selectedOptions[0].value);
	}

	updateCountryField(value) {
		const country = this.country;
		if (!country) {
			return;
		}

		country.value = value;

		const countryChangeEvent = new Event('change');
		country.dispatchEvent(countryChangeEvent);
	}

	updateStateField(value) {
		const state = this.state;
		if (!state) {
			return;
		}

		state.value = value;

		const stateChangeEvent = new Event('change');
		state.dispatchEvent(stateChangeEvent);
	}
}
